import React from "react"

import { Typography } from "antd"

import ImageWithPreview from "../../../../../Components/ImageWithPreview"
import Icon from "../../../../../Icon"

import styles from "../CreditRequestInstructions.module.less"

const { Text } = Typography

export const ImagePreview = ({ src, alt }) => {
  return (
    <div className={styles.imagePreview}>
      <ImageWithPreview src={src} alt={alt} className={styles.imagePreviewImage} />
      <Text type="secondary" className={styles.imagePreviewText}>
        <Icon className={styles.fullScreenIcon} type="full_screen" /> Click on the image to open it
        full screen.
      </Text>
    </div>
  )
}
